import axios from 'axios'
import Signer from '@/models/Signer'

export default class {
  _signersUrl
  _notifySingersUrl

  constructor() {
    this._signersUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_SIGNERS}`
    this._notifySingersUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_NOTIFY_SIGNERS}`
  }

  getSignersByDocumentId(documentId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this._signersUrl}/${documentId}`)
        .then(result => {
          if (result.data.success) {
            let resultSigners = result.data.data
            let signers = []

            if (resultSigners) {
              signers = resultSigners.map((s) => {
                let sig = Object.assign(new Signer(), s)
                sig.email = s.correoElectronico
                sig.id = s.idFirmante
                return sig
              })
            }

            resolve({
              success: true,
              data: signers
            })
          }
        })
        .catch(err => {
          let errorMessage = ''
          if (err.response) {
            if (err.response.data.error.message) {
              errorMessage = err.response.data.error.message
            } else {
              errorMessage =
                'Ocurrió un error al buscar el firmante del documento.'
            }

            reject({
              success: false,
              errorMessage
            })
          } else {
            reject({
              success: false,
              errorMessage: err
            })
          }
        })
    })
  }

  notifySigners(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(this._notifySingersUrl, data)
        .then(result => {
          resolve({
            success: true,
            data: result
          })
        })
        .catch(err => {
          reject({
            success: false,
            errorMessage: err
          })
        })
    })
  }

  notifySignerById(signerId, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this._notifySingersUrl}/${signerId}`, data)
        .then(result => {
          resolve({
            success: true,
            data: result
          })
        })
        .catch(err => {
          reject({
            success: false,
            errorMessage: err
          })
        })
    })
  }

  createSigners(signerXDocument) {
    return new Promise((resolve, reject) => {
      axios.post(this._signersUrl, signerXDocument)
        .then(result => {
          if (result.data.successful.code == 'SIGNER-POST-201') {
            let signers = []
            result.data.data.signers.map(s => {
              if(s.success && s.successful.code == 'SIGNER-POST-200'){
                let signer = Object.assign(new Signer(), s.data)
                signer.email = s.data.correoElectronico
                signer.id = s.data.idFirmante
                signers.push(signer)
              }
            })
            
            if(signers.length>0){
              resolve(signers)
            }
            
            let error = result.data.data.signers.find(s => !s.success)
            reject(error)
          } else {
            reject(result)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  updateSignerToDocument(id, signer) {
    return new Promise((resolve, reject) => {
      axios.put(`${this._signersUrl}/${id}`, signer)
        .then(result => {
          if (result.data.successful.code == 'SIGNER-PUT-200') {
            let sig = Object.assign(new Signer(), signer)
            sig.nombres = result.data.data.nombres
            sig.paterno = result.data.data.paterno
            sig.materno  = result.data.data.materno
            sig.rfc = result.data.data.rfc
            sig.email = result.data.data.correoElectronico
            sig.id = result.data.data.idFirmante
            resolve(sig)
          } else {
            reject(result)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  deleteSignerToDocument(signer) {
    let data = {
      firmantes: [
        {
          email: signer.email,
          idFirmante: signer.idFirmante
        }
      ]
    }

    return new Promise((resolve, reject) => {
      axios.delete(this._signersUrl, { headers: {}, data: data })
        .then(result => {
          if (result.data.successful.code == 'SIGNER-DELETE-200' &&
              result.data.data.signers[0].success &&
              result.data.data.signers[0].successful.code == 'SIGNER-DELETE-201'
          ) {
            resolve(result)
          } else {
            reject(result)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  reminderSignerToDocument(data) {
    let notificacion = { tipoNotificacion: data.notificacion }
    
    return new Promise((resolve, reject) => {
      axios.post(`${this._notifySingersUrl}/${data.id}`, notificacion)
        .then(result => {
          if (result.data.successful.code == 'NOTIFY-SIGNER-POST-201' &&
              result.data.data.notifications[0].success &&
              result.data.data.notifications[0].successful.code == 'NOTIFY-SIGNER-POST-200'
          ) {
            resolve(result)
          } else {
            reject(result)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
